import VideosOnDemandScreen from './VideosOnDemand';

export default VideosOnDemandScreen;
